/** @format */

/**
 * NOTE: All dictionary values/keys must be in camel case
 */

const _z = {};
export default _z;
